<template>
    <div class="activityPageWarp">
        <div v-if="dataList.length!=0">
            <div class="datalistBox">
                <div class="leftImgRightTextBox">
                    <div v-for="(item,index) in dataList" :key="index" class="itemBox" @click="goNewsDetailFn(item)">
                        <img :src="srcUrl+item.titleImgUrl" class="imgbox" />
                        <div class="contentbox">
                            <div class="title overflowone">{{item.pressTopic}}</div>
                            <div class="synopsis overflowone">{{item.synopsis}}</div>
                            <div class="newsyearmonth">{{item.pressTime | timer}}</div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                    :page-sizes="[6]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <div v-else>
            <div class="emptyBox">
                <img src="@/assets/imgs/branchempty.jpg" />
            </div>
        </div>
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
    data() {
        return {
            srcUrl: srcUrl,
            currentPage: 1,
            total: 0,
            pageSize: 6,
            dataList: []
        }
    },
    mounted() {
        this.getNews()
    },
    methods: {
        async getNews() {
            let params = {
                pageSize: this.pageSize,
                pageCurrent: this.currentPage,
                pressSuperClass:89,
                // branchRegion: 9,
            };
            let data = await httpService.getNewsList(params);
            if (data.code == 200) {
                this.dataList = data.result.list
                this.total = data.result.total;
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getNews();
        },
        handleCurrentChange(val) {
            // this.pageSize = 1;
            this.currentPage = val;
            this.getNews();
        },
        goNewsDetailFn(val) {
            this.$router.push({
                path: "/news-detail",
                query: {
                    id: val.pressId,
                },
            });
        }
    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.activityPageWarp {
	width: 100%;
	.datalistBox {
		min-height: 520px;
		.leftImgRightTextBox {
			.itemBox {
				margin: 0 0 40px 0;
				width: 100%;
				cursor: pointer;
                &:hover {
					.contentbox {
						.title {
							color: #448df7;
						}
					}
				}
				.dateBox {
					width: 100px;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
				}
				.imgbox {
					width: 149px;
					height: 93px;
				}
				.contentbox {
					width: 79%;
					display: flex;
					flex-direction: column;
					.title {
						font-size: 18px;
						line-height: 28px;
						color: #333;
					}
					.synopsis {
						min-height: 30px;
						font-size: 16px;
						line-height: 30px;
						color: #333;
					}
					.newsyearmonth {
						font-size: 16px;
						line-height: 36px;
						color: #999999;
					}
				}
			}
		}
	}
    .emptyBox {
		img {
			width: 198px;
			height: 200px;
		}
	}
}
</style>


